import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Path from '@leverege/path'

import { DeviceFactory } from '../../editors/device'
import { BreadcrumbActions, DeviceActions, SystemActions, BlueprintActions, DeviceUpdater } from '../../actions'
import style from './style.css'

class DeviceInfoScreen extends React.Component {

  componentDidMount() {
    const { dispatch, match : { params : { deviceId, systemId, blueprintId, projectId } } } = this.props

    dispatch( SystemActions.get( systemId ) )
    dispatch( DeviceActions.getDevice( systemId, deviceId ) )
    if ( blueprintId ) {
      dispatch( BlueprintActions.getBlueprint( projectId, blueprintId ) )
    }
  }

  componentDidUpdate( prevProps, prevState ) {
    // TODO : move out to device/system/project history page
    // get blueprint if we need it
    const { dispatch, match : { params : { deviceId, projectId, systemId, blueprintId } }, devices, blueprint, systems } = this.props

    const sName = Path( [ 'lookup', systemId, 'name' ] ).get( systems, null )
    const dName = Path( [ 'lookup', deviceId, 'name' ] ).get( devices, null )
    const bName = Path( 'data/name' ).get( blueprint, null )

    if ( blueprintId ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${projectId}/system` }, 
          { name : sName || systemId, link : `/project/${projectId}/system/${systemId}/device` },
          { name : bName || blueprintId, link : `/project/${projectId}/system/${systemId}/blueprint/${blueprintId}/device` },
          { name : dName || deviceId } ] ) )
    } else {
      dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${projectId}/system` }, 
          { name : sName || systemId, link : `/project/${projectId}/system/${systemId}/device` },
          { name : dName || deviceId } ] ) )
    }
  }

  onDeviceChange = ( evt ) => {
    const { dispatch } = this.props
    DeviceUpdater( dispatch, evt.target )
      .set( evt.path, evt.value )
      .done();
  }

  render() {
    const { match : { params : { deviceId } }, devices, networks } = this.props
    const device = devices && devices.lookup && devices.lookup[deviceId]
    const details = DeviceFactory.createEditor( device, { networks, device, onChange : this.onDeviceChange, showHeader : false } );
    return <div className={style.info}>{details}</div>
  }
}

export default connect(
  state => ( {
    devices : state.devices,
    blueprint : state.blueprint,
    networks : state.networks,
    systems : state.systems
  } )
)( DeviceInfoScreen )
